/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'APP_THEME/_common/legacy/core.mobile';

import 'resources/less/themes/base/pages/landing_page.less';

import 'APP_THEME/_common/main_page_blocks/index';
import RoyalSlider from 'APP_THEME/_common/royal_slider/index';

$(function() {
    const royalSlider = new RoyalSlider($('.royalSlider'), { autoHeight: true, fitInViewport: false });
});
